import { Box, Grid, Tab, Typography } from "@mui/material";
import { forwardRef, Ref } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../app/hooks";
import { BORDER } from "../constants";
import { selectInboxSummary } from "../messagingSlice";
import { MessagingInboxTabsStyled, MessagingInboxUnreadBadge } from "../styles";

type Props = {
  ref: Ref<HTMLDivElement>;
  value: number | false;
  handleTabChange: (newValue: number) => void;
};

const formatTabLabel = (label: string, count?: number) => (
  <Box display="flex" alignItems="center" gap="6px">
    <Typography variant="header" noWrap>
      {label}
    </Typography>
    {count !== undefined && (
      <Typography variant="body2" color="text.secondary" mr="4px" ml="2px">
        {count}
      </Typography>
    )}
  </Box>
);

const MessagingInboxTabs = forwardRef<HTMLDivElement, Props>(
  function MessagingInboxTabs({ value, handleTabChange }, ref) {
    const { t } = useTranslation("messaging");
    const inboxSummary = useAppSelector(selectInboxSummary);
    const inProgressUnread = inboxSummary?.inProgress.unread ?? 0;

    return (
      <Grid
        ref={ref}
        item
        xs={12}
        sx={{
          width: "100%",
          height: "56px",
          borderBottom: BORDER,
        }}
      >
        <MessagingInboxTabsStyled
          value={value}
          onChange={(_, value) => handleTabChange(value)}
        >
          <Tab
            label={formatTabLabel(t("teamOpenTab"), inboxSummary?.teamOpen)}
          />
          <Tab label={formatTabLabel(t("openTab"), inboxSummary?.myOpen)} />
          <Tab
            label={
              <MessagingInboxUnreadBadge
                badgeContent={inProgressUnread}
                invisible={!inProgressUnread}
              >
                {formatTabLabel(
                  t("inProgressTab"),
                  inboxSummary?.inProgress.total,
                )}
              </MessagingInboxUnreadBadge>
            }
          />
          <Tab label={formatTabLabel(t("closedTab"))} />
        </MessagingInboxTabsStyled>
      </Grid>
    );
  },
);

export default MessagingInboxTabs;
